import { hasLocation } from "./constructor_state.js";

export function validateConstructorState(state) {
  const partialAreaInvalid = state.partialSelection.checked && state.partialArea > 0 && state.area > 0 && state.partialArea > state.area;
  const razvortkyAreaInvalid = state.razvortkySelection.checked && state.razvortkyArea > 0 && state.area > 0 && state.razvortkyArea > state.area;

  return {
    partialAreaInvalid,
    razvortkyAreaInvalid,
    locationMissing: !hasLocation(state),
    isBusinessValid: !partialAreaInvalid && !razvortkyAreaInvalid,
  };
}

export function validateModalContact({ clientName, phoneNumber }) {
  const name = (clientName || "").trim();
  const phone = (phoneNumber || "").trim();
  const digits = phone.replace(/\D/g, "");

  const nameInvalid = name.length === 0;
  const phoneInvalid = digits.length < 5 || digits.length > 15;

  return {
    name,
    phone,
    digits,
    nameInvalid,
    phoneInvalid,
    isValid: !nameInvalid && !phoneInvalid,
  };
}
